import React from "react";
import { Modal, button, Form, Row, Col } from "react-bootstrap";

const AddNewModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered className="add-new-program">
      <div className="p-2">
        <Modal.Header className="p-2" closeButton>
          <Modal.Title>
            {" "}
            <h5 className="font-20 font-weight-bold heading-color">
              Add New
            </h5>{" "}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Program Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Program Name"
                className="input-field"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label className="label-input">Manager</Form.Label>
              <Form.Select className="input-field">
                <option value="">Select</option>
                <option value="manager1">John Doe</option>
                <option value="manager2">Jane Smith</option>
                <option value="manager3">Mike Johnson</option>
              </Form.Select>
            </Form.Group>
            <Row className="mt-5">
              <Col lg={6}>
                <button className="c-b-btn w-100" onClick={handleClose}>
                  Cancel
                </button>
              </Col>
              <Col lg={6}>
                <button className="n-u-btn w-100" onClick={handleClose}>
                  Update
                </button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default AddNewModal;
